import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IMG_PRODUCT1 } from "@/lib/images";
import { Mail, ShoppingBag } from "lucide-react";

const products = [
  {
    id: "fresh-breath-delight",
    name: "Fresh Breath Delight",
    subtitle: "Breath Spray",
    flavor: "Peppermint",
    ingredients: "grape seed oil, peppermint, hydrogen peroxide, stevia, and distilled water.",
    price: "$10.00",
    img: IMG_PRODUCT1,
  },
];

export default function Shop() {
  return (
    <div className="App">
      <Navbar />
      <section className="max-w-6xl mx-auto px-6 pt-32 pb-20">
        <p className="label text-sm uppercase tracking-[0.15em] text-[#78698A] font-semibold flex items-center gap-2">
          <ShoppingBag className="h-4 w-4" /> Shop
        </p>
        <h1 className="font-serif text-5xl text-[#2D2336] mt-3">Products by UDC</h1>
        <p className="text-lg text-[#5C5166] mt-4 max-w-2xl">
          Quality oral care products from Utopia Dental Care. More items coming soon.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" data-testid="shop-products">
          {products.map((p) => (
            <div key={p.id} data-testid={`product-${p.id}`} className="bg-white border border-[#E5DEEB] rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow group">
              <div className="bg-[#F6F2FA] p-6 flex items-center justify-center">
                <img src={p.img} alt={p.name} className="h-64 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <h3 className="font-serif text-2xl text-[#2D2336]">{p.name}</h3>
                <p className="text-[#5C5166] mt-0.5">{p.subtitle}</p>
                <p className="text-sm text-[#5C5166] mt-4"><span className="font-semibold text-[#2D2336]">Flavor:</span> {p.flavor}</p>
                <p className="text-sm text-[#5C5166] mt-2"><span className="font-semibold text-[#2D2336]">Ingredients:</span> {p.ingredients}</p>
                <p className="text-2xl font-semibold text-[#6B4C8A] mt-4">{p.price}</p>
                <a
                  href={`mailto:utopiadentalcare@gmail.com?subject=Order inquiry: ${encodeURIComponent(p.name)}`}
                  data-testid={`order-${p.id}`}
                  className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-[#6B4C8A] text-white py-3 rounded-full font-medium hover:bg-[#543C6E] transition-colors"
                >
                  <Mail className="h-4 w-4" /> Order via Email
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
